import type { BadgeTone } from '../components/ui';

/** client_content_queue.status, in workflow order. The check constraint on the table lists the same values. */
export type ContentQueueStatus =
  | 'queue_submitted'
  | 'queue_approved'
  | 'queue_denied'
  | 'being_built'
  | 'awaiting_publish_approval'
  | 'published';

export const CONTENT_QUEUE_STATUSES: { value: ContentQueueStatus; label: string; tone: BadgeTone }[] = [
  { value: 'queue_submitted', label: 'Queue Submitted', tone: 'neutral' },
  { value: 'queue_approved', label: 'Queue Approved', tone: 'info' },
  { value: 'queue_denied', label: 'Queue Denied', tone: 'down' },
  { value: 'being_built', label: 'Being Built', tone: 'accent' },
  { value: 'awaiting_publish_approval', label: 'Awaiting Publish Approval', tone: 'warn' },
  { value: 'published', label: 'Published', tone: 'up' },
];

export const DEFAULT_CONTENT_QUEUE_STATUS: ContentQueueStatus = 'queue_submitted';

/** The status's label and tone; an unknown value (a status added in the database first) shows as itself, neutral. */
export const contentQueueStatus = (value: string) =>
  CONTENT_QUEUE_STATUSES.find((s) => s.value === value) ?? { value, label: value, tone: 'neutral' as BadgeTone };
